import { formatNumber } from "../data/essential";
import moment from "moment";
import { editHouse } from "../../utils/roles";
export const houseColumns = (roles,openModal,setRow) => {
  const columns = [
    {
      name: "Id",
      cell: (row) => <div className='hover'>{row["id"]}</div>,
    },
    {
      name: "Account",
      cell: (row) => <div>{row["accountId"]}</div>,
    },
    { name: "Location Id", cell: (row) => row["locationId"] },
    { name: "Category", cell: (row) => row["category"]["name"] },
    { name: "Status", cell: (row) => row["status"]["name"] },
    {
      name: "Owner Id",
      cell: (row) => row["ownerSubscriberId"],
    },
    {
      name: "Monthly Fee",
      cell: (row) => `${formatNumber(row?.securityFeeAmount)} RWF`,
    },
    {
      name: "Created On",
      cell: (row) => moment(row?.createdAt).format("DD-MM-YYYY hh:mm:ss A"),
    },
    {
      name: roles?.some((role) => role.id === editHouse)
        ? "Edit house"
        : "",
      cell: (row) => (
        <div className='d-flex justify-content-center' style={{ width: "80%" }}>
          {roles?.some((role) => role.id === editHouse) ? (
            <i
              style={{ color: "#0000ff", cursor: "pointer" }}
              className='fa fa-pen'
              onClick={() => {
                openModal();
                setRow(row);
              }}
            />
          ) : null}
        </div>
      ),
    },
  ];
  return columns
}
export const columns = [
  {
    name: "Id",
    cell: (row) => <div className='hover'>{row["id"]}</div>,
  },
  {
    name: "Account",
    cell: (row) => <div>{row["accountId"]}</div>,
  },
  { name: "Location", cell: (row) => row["location"] },
  { name: "Category", cell: (row) => row["category"] },
  { name: "Status", cell: (row) => row["status"] },
  {
    name: "Owner Id",
    cell: (row) => row["ownerSubscriberId"],
  },
  {
    name: "Monthly Fee",
    cell: (row) => `${row?.securityFeeAmount} RWF`,
  },
  {
    name: "Created On",
    cell: (row) => row?.createdAt,
  },
];
  